type ZeroToFifty =
  | 0
  | 1
  | 2
  | 3
  | 4
  | 5
  | 6
  | 7
  | 8
  | 9
  | 10
  | 11
  | 12
  | 13
  | 14
  | 15
  | 16
  | 17
  | 18
  | 19
  | 20
  | 21
  | 22
  | 23
  | 24
  | 25
  | 26
  | 27
  | 28
  | 29
  | 30
  | 31
  | 32
  | 33
  | 34
  | 35
  | 36
  | 37
  | 38
  | 39
  | 40
  | 41
  | 42
  | 43
  | 44
  | 45
  | 46
  | 47
  | 48
  | 49
  | 50;
type SpacingKey = `spacing_${ZeroToFifty}`;

const BASE_SPACING = 4;

export const spacing = Array.from({ length: 51 }, (_, i) => i).reduce((acc, cur) => {
  acc[`spacing_${cur}` as SpacingKey] = `${cur * BASE_SPACING}px`;
  return acc;
}, {} as Record<`spacing_${ZeroToFifty}`, string>);
